/* Digital Turn — compatibility loader. Keeps legacy product-card includes lightweight. */
(function(){
  if(window.__DT_ELMORE_GRID__||window.__DT_ELMORE_GRID_RUNTIME_LOADING__) return;
  window.__DT_ELMORE_GRID_RUNTIME_LOADING__=true;
  var cur=document.currentScript;
  if(!cur||!cur.src){window.__DT_ELMORE_GRID_RUNTIME_LOADING__=false;return;}
  var u=new URL(cur.src,location.href);
  u.pathname=u.pathname.replace(/dt-product-grid-shared\.js$/,'dt-product-grid-runtime.js');
  u.search='';
  var s=document.createElement('script');
  s.src=u.href;
  s.defer=true;
  s.onload=function(){window.__DT_ELMORE_GRID_RUNTIME_LOADING__=false;};
  s.onerror=function(){window.__DT_ELMORE_GRID_RUNTIME_LOADING__=false;};
  document.head.appendChild(s);
})();
